import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MembereditorModule } from '../membereditor/membereditor.module';
import { TreeeditorModule } from '../treeeditor/treeeditor.module';
import { CommonComponentModule } from '../common/common.module';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { FamilyeditorModule } from '../familyeditor/familyeditor.module';
import { IndividualeditorModule } from '../individualeditor/individualeditor.module';
import { EditorMenuComponent } from './editor-menu/editor-menu.component';



@NgModule({
  declarations: [EditorMenuComponent],
  exports: [EditorMenuComponent],
  imports: [
    CommonModule,
    MembereditorModule,    
    TreeeditorModule,
    IndividualeditorModule,
    RouterModule,
    CommonComponentModule,
    FamilyeditorModule,
    SharedModule
  ]
})
export class EditorModule { }
// translation loader moved to SharedModule
